const SaleInvoice_sample = [
  {
    orderData: {
      soit_id: "soit_id",
      store_id: "store_id",
      cmr_id: "cmr_id",
      cmr_phone_number: "cmr_phone_number",
      soit_total_gst: "soit_total_gst",
      soit_total_discount: "soit_total_discount",
      soit_payment_status: "soit_payment_status",
      soit_transaction_id: "soit_transaction_id",
      soit_order_status: "soit_order_status",
      soit_payment_method: "soit_payment_method",
      soit_billing_address: "soit_billing_address",
      soit_total_amount: "soit_total_amount",
      soit_sub_total: "soit_sub_total",
      soit_round_off_value: "soit_round_off_value",
      soit_delivery_date: "soit_delivery_date",
      soit_document_date: "soit_document_date",
      cmr_code: "cmr_code",
      cmr_name: "cmr_name",
      remarks: "remarks",
      created_date: "created_date",
      update_date: "update_date",
      inv_no: "inv_no",
      document_date: "document_date",
      tds_tcs_type: "tds_tcs_type",
      tcs_or_tds_percentage: "tcs_or_tds_percentage",
      tcs_or_tds_amount: "tcs_or_tds_amount",
      tcs_or_tds_percentage_id: "tcs_or_tds_percentage_id",
      soit_invoice_discount: "soit_invoice_discount",
      soit_invoice_discount_percentage: "soit_invoice_discount_percentage",
      soit_is_invoice_dis_percentage: "soit_is_invoice_dis_percentage",
      soit_ship_to_address: "soit_ship_to_address",
      soit_pay_to_address: "soit_pay_to_address"
    },
    itemData: [
      {
        item_id: "item_id",
        sodtt_id: "sodtt_id",
        sott_id: "sott_id",
        item_code: "item_code",
        item_generic_name: "item_generic_name",
        item_name: "item_name",
        item_pack_size: "item_pack_size",
        item_rack_location: "item_rack_location",
        item_unit_price: "item_unit_price",
        item_quantity: "item_quantity",
        item_schedule: "item_schedule",
        item_discount_amount: "item_discount_amount",
        item_discount_percentage: "item_discount_percentage",
        item_tax_amount: "item_tax_amount",
        item_batch_number: "item_batch_number",
        item_credit_quanity_remaining: "item_credit_quanity_remaining",
        item_total_tax_percentage: "item_total_tax_percentage",
        item_total_amount: "item_total_amount",
        item_batch_quantity: "item_batch_quantity",
        item_exp_date: "item_exp_date",
        item_gst: "item_gst",
        item_sgst: "item_sgst",
        item_cgst: "item_cgst",
        item_igst: "item_igst",
        item_uom: "item_uom",
        item_hsn: "item_hsn",
        item_manufacturer_id: "item_manufacturer_id",
        item_manufacturer_name: "item_manufacturer_name",
        item_free_quantity: "item_free_quantity",
        itemBatchData: [
          {
            item_batch_number: "item_batch_number",
            item_id: "item_id",
            item_batch_quantity: "item_batch_quantity",
            item_exp_date: "item_exp_date",
            item_batch_purchase_rate: "item_batch_purchase_rate",
            item_batch_unit_price: "item_batch_unit_price",
            from_bin_location: "from_bin_location",
            from_bin_id: "from_bin_id",
            item_batch_free_quantity: "item_batch_free_quantity",
            item_batch_discount_amount: "item_batch_discount_amount",
            item_batch_discount_percentage: "item_batch_discount_percentage",
            item_batch_tax_percentage: "item_batch_tax_percentage",
            item_batch_tax_amount: "item_batch_tax_amount",
            item_batch_total_sales_rate: "item_batch_total_sales_rate",
            item_batch_final_sales_rate: "item_batch_final_sales_rate",
            item_batch_sales_rate: "item_batch_sales_rate",
            item_batch_total_base_sales_rate: "item_batch_total_base_sales_rate",
            item_batch_discounted_sales_rate: "item_batch_discounted_sales_rate"
          },
          {
            item_batch_number: "item_batch_number",
            item_id: "item_id",
            item_batch_quantity: "item_batch_quantity",
            item_exp_date: "item_exp_date",
            item_batch_unit_price: "item_batch_unit_price",
            from_bin_location: "from_bin_location",
            from_bin_id: "from_bin_id",
            item_batch_free_quantity: "item_batch_free_quantity",
            item_batch_discount_amount: "item_batch_discount_amount",
            item_batch_discount_percentage: "item_batch_discount_percentage",
            item_batch_tax_percentage: "item_batch_tax_percentage",
            item_batch_tax_amount: "item_batch_tax_amount",
            item_batch_total_sales_rate: "item_batch_total_sales_rate",
            item_batch_final_sales_rate: "item_batch_final_sales_rate",
            item_batch_sales_rate: "item_batch_sales_rate",
            item_batch_total_base_sales_rate: "item_batch_total_base_sales_rate",
            item_batch_discounted_sales_rate: "item_batch_discounted_sales_rate"
          }
        ],
        total_sellable_quantity: "total_sellable_quantity"
      }
    ]
  }
];
const storeDetailsResult_sample = [
  {
    company: "COMAPNY_NAME",
    company_address: "COMPANY_LOCATION",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_XX_XX",
    dl_no_21_21b: "DRUG_LICENSE_XX_XX",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default {SaleInvoice_sample,storeDetailsResult_sample};